export const isEqual = (numOne: string, numTwo: string): boolean => {
    var _numOne
    if (numOne.charAt(0) === '+') {
        if (numOne.charAt(1) === '1') {
            _numOne = numOne.substring(2)
        } else {
            _numOne = numOne.substring(1)
        }
    } else {
        if (numOne.charAt(0) === '1') {
            _numOne = numOne.substring(1)
        } else {
            _numOne = numOne.substring(0)
        }
    }

    var _numTwo
    if (numTwo.charAt(0) === '+') {
        if (numTwo.charAt(1) === '1') {
            _numTwo = numTwo.substring(2)
        } else {
            _numTwo = numTwo.substring(1)
        }
    } else {
        if (numTwo.charAt(0) === '1') {
            _numTwo = numTwo.substring(1)
        } else {
            _numTwo = numTwo.substring(0)
        }
    }

    return _numOne.replace(/\D/g, '') === _numTwo.replace(/\D/g, '')
}

export const formatInput = (value: string = '', previousValue: string = ''): string => {
    // return nothing if no value
    if (!value) return value

    // Removes the `+1` or `1` US country code if available.
    value = value.replace(/^(\+?1)/, '')

    // only allows 0-9 inputs
    const currentValue = value.replace(/[^\d]/g, '')
    const cvLength = currentValue.length

    if (!previousValue || value.length > previousValue.length) {

        // returns: "x", "xx", "xxx"
        if (cvLength < 4) return currentValue

        // returns: "(xxx)", "(xxx) x", "(xxx) xx", "(xxx) xxx",
        if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`

        // returns: "(xxx) xxx-", (xxx) xxx-x", "(xxx) xxx-xx", "(xxx) xxx-xxx", "(xxx) xxx-xxxx"
        return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`
    } else {
        // returns: "x", "xx", "xxx"
        if (cvLength < 4) return currentValue

        // returns: "(xxx)", "(xxx) x", "(xxx) xx", "(xxx) xxx",
        if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`

        // returns: "(xxx) xxx-", (xxx) xxx-x", "(xxx) xxx-xx", "(xxx) xxx-xxx", "(xxx) xxx-xxxx"
        return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`
    }
}

export const normalizeInput = (phone: string): string => {
    let value: string = phone.replace(/\D/g,'')
    let newPhone = value.split(/\+1(.+)/)
    return (newPhone.length === 3) ? newPhone[1] : newPhone[0]
}